export interface BreadcrumbAncestor {
  label: string
  href: string
}

/**
 * Natural list-page ancestor for detail/sub pages, keyed by feature. Consumed
 * via `<PageHeader ancestor={BREADCRUMB_ANCESTORS.x} sticky ... />`. Single
 * source of truth so label/href never drift between call sites.
 *
 * Customer routes only — the nine `/admin/*` ancestors went with the admin
 * panel (goal 247); admin breadcrumbs live in the console now.
 */
export const BREADCRUMB_ANCESTORS = {
  federalTax: { label: 'Federal Tax', href: '/federal-tax' },
  stateFilings: { label: 'State filings', href: '/state-filings' },
  services: { label: 'Services', href: '/services' },
} as const satisfies Record<string, BreadcrumbAncestor>
